module.exports = __webpack_public_path__ + "static/media/mangue.d98a95cb.svg";